import { render, staticRenderFns } from "./WordExplorer.vue?vue&type=template&id=aeeee2be&scoped=true&"
import script from "./WordExplorer.vue?vue&type=script&lang=js&"
export * from "./WordExplorer.vue?vue&type=script&lang=js&"
import style0 from "./WordExplorer.vue?vue&type=style&index=0&id=aeeee2be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeeee2be",
  null
  
)

component.options.__file = "WordExplorer.vue"
export default component.exports